import styled from "styled-components";
const NumberSelector=({setError,error,selectdNumber,setSelectedNumber})=>{
    const arrNumber=[1,2,3,4,5,6];
    const numberSelectorHandler=(value)=>{
        setSelectedNumber(value);
        setError("");
        console.log(value);
    }
    return(
        <NumberSelectorContainer>
            {error&&<p className="error">{error}</p>}
            <div className="flex">

            {arrNumber.map((value,i)=>{
               return( <Box isSelected={value === selectdNumber} key={i} onClick={()=>numberSelectorHandler(value)}>{value}</Box>)
            })}
            </div>
            <p>Select Number</p>
            
        </NumberSelectorContainer>
    )
}
export default NumberSelector;
const NumberSelectorContainer=styled.div`
    display:flex;
    flex-direction:column;
    align-items:end;
    .flex{
        display:flex;
        gap:24px;
    }
    p{
        font-size:20px;
        font-weight:700;
    }
    .error{
        color:red;
        font-size:16px;
    }
`;
const Box=styled.div`
    height:60px;
    width:60px;
    border:1px solid #111;
    display:grid;
    place-items:center;
    font-size:24px;
    font-weight:700;
    background-color:${(props)=>(props.isSelected? "black":"white")};
    color:${(props)=>(props.isSelected?"white":"black")}
`;
